/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  TemplateRef,
  ContentChild
} from '@angular/core';
import { Table, TableStyle, TableModule } from 'primeng/table';

// Types
import type { TableFooter, TableGroup } from './m-table.component.types';
import { PrimeTemplate } from 'primeng/api';
import { NgClass, NgTemplateOutlet } from '@angular/common';

/**
 * MTableComponent - A table component with customizable columns, groups, and footers.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-table',
  templateUrl: './m-table.component.html',
  providers: [TableStyle],
  imports: [TableModule, PrimeTemplate, NgClass, NgTemplateOutlet]
})
export class MTableComponent extends Table {
  /** Grouped columns for the table */
  @Input() groupedColumns?: TableGroup[];
  /** Footer data for the table */
  @Input() footerData?: TableFooter[];

  @ContentChild('customBody') customBody!: TemplateRef<any>;

  // PrimeNG 20 applies the root class on the host via `host: { '[class]': "cn(cx('root'), styleClass)" }`.
  // This wrapper extends Table but renders its OWN inner <p-table>, so that metadata is inherited onto
  // <m-table> too — duplicating the datatable root styling on the wrapper host.
  // Neutralize on the wrapper host; the inner table is unaffected.
  override cx(): string {
    return '';
  }
}
